<template>
  <v-container id="cobros-pendientes">
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="4">
            <v-menu ref="fechaMin" v-model="fechaMin" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
              <template v-slot:activator="{ on }">
                <v-text-field v-model="fMin" color="gold" label="Fecha desde" readonly v-on="on" />
              </template>
              <v-date-picker v-model="fMin" color="gold" landscape scrollable locale="es-419" no-title @input="fechaMin = false" />
            </v-menu>
          </v-col>
          <v-col cols="12" md="4">
            <v-menu ref="fechaMax" v-model="fechaMax" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
              <template v-slot:activator="{ on }">
                <v-text-field v-model="fMax" color="gold" label="Fecha hasta" readonly v-on="on" />
              </template>
              <v-date-picker v-model="fMax" color="gold" landscape scrollable locale="es-419" no-title @input="fechaMax = false" />
            </v-menu>
          </v-col>
          <v-col cols="12" md="4">
            <v-autocomplete
              v-model="search"
              :items="jugadores"
              item-value='fullName'
              item-text='fullName'
              :label="'Jugador'"
              color="gold"
              clearable
            >
              <template v-slot:item="{ attrs, item, on }">
                <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                  <v-list-item-content>
                    <v-list-item-title v-text="item.fullName" />
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row justify="space-between">
          <v-col cols="12" md="8">
            <v-row>
              <v-col cols="12" md="6">
                <v-select v-model="TipoContratoSelec" color="gold" :items="tipoContrato" label="Tipo contrato" clearable return-object item-text="descripcion">
                  <template v-slot:itemm="{ attrs, itemm, on }">
                    <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                      <v-list-item-content>
                        <v-list-item-title v-text="itemm.descripcion" />
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select v-model="contraparteSelected" color="gold" :items="contraparte" label="Contraparte" clearable return-object item-text="descripcion">
                  <template v-slot:itemm="{ attrs, itemm, on }">
                    <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                      <v-list-item-content>
                        <v-list-item-title v-text="itemm" />
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="auto" align-self="center" @click="aplicarFiltros">
            <v-btn class="">
              <v-icon dark class="pr-2 pl-0">
                mdi-magnify
              </v-icon>
              Aplicar filtro
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-row v-if="monedas.length !== 0" class="px-3">
      <v-expansion-panels v-model="open" multiple>
        <v-expansion-panel v-for="(value, key) in monedas" :key="key">
          <v-expansion-panel-header>
            <span>{{ value.descripcion }}</span>
            <template v-slot:actions>
              <v-row>
                <v-progress-circular v-if="!terminototales[value.id]" indeterminate color="gold" />
                <strong v-else>{{ totales[value.id] }}</strong>
                <v-icon class="ml-2">
                  mdi mdi-chevron-down
                </v-icon>
              </v-row>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <cobros-pendientes-tabla :moneda-id="value.id" :urlparametrizada="urlparametrizada" @cambioTotal="actualizarTotales" />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </v-container>
</template>

<script>
  import CobrosPendientesTabla from './components/CobrosPendientesTabla.vue'
  import dayjs from 'dayjs'
  import Vue from 'vue'

  export default {
    name: 'CobrosPendientes',
    components: {
      CobrosPendientesTabla,
    },
    data () {
      return {
        monedas: [],
        monedasAux: [],
        totales: [],
        terminototales: [],
        tipoContrato: [],
        jugadores: [],
        fechaMax: false,
        fechaMin: false,
        sortby: ['vencimiento'],
        sortdesc: [false],
        TipoContratoSelec: undefined,
        contraparteSelected: '',
        contraparte: ['Jugador', 'Club'],
        fMin: '',
        fMax: '',
        search: '',
        urlparametrizada: '',
        open: [0],
      }
    },
    computed: {},
    created () {
      this.getJugadores()
      this.getTiposContratos()
      this.inic()
    },
    methods: {
      aplicarFiltros () {
        this.getUrlParametrizada()
      },
      getDataConTotal () {},
      inic () {
        const today = dayjs()
        this.fMin = today.format('YYYY-MM-DD')
        this.fMax = dayjs(today.add(1, 'month')).format('YYYY-MM-DD')
        this.getUrlParametrizada()
        this.getMoneda()
      },
      getUrlParametrizada (page = 1) {
        const tipoContrato = ((this.TipoContratoSelec !== undefined) ? this.TipoContratoSelec.id : '')
        const jugador = ((this.search) ? this.search : '')
        const contraparte = ((this.contraparteSelected !== undefined) ? this.contraparteSelected : '')
        const urlparametrizada = '&fmin=' + this.fMin + '&fmax=' + this.fMax + '&search=' + jugador + '&tipoContrato=' + tipoContrato + '&contraparte=' + contraparte
        this.urlparametrizada = urlparametrizada
      },
      getJugadores: function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/jugador' }).then(response => { this.jugadores = response })
      },
      getTiposContratos () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/tipo_contrato_get' }).then(response => {
          this.tipoContrato = response
        })
      },
      getMoneda () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/moneda' }).then(response => {
          this.monedasAux = response
          this.$nextTick(() => {
            this.generartabs()
          })
        })
      },
      generartabs () {
        this.monedasAux.forEach(element => {
          this.terminototales[element.id] = false
        })
        this.buscarTab(0, 1)
      },
      actualizarTotales (datos) {
        Vue.set(this.terminototales, [datos.moneda_id], false)
        Vue.set(this.totales, [datos.moneda_id], datos.total)
        Vue.set(this.terminototales, [datos.moneda_id], true)
        this.paneles = []
        for (var i = 0; i < this.monedas.length; i++) {
          this.paneles.push(i)
        }
      },
      buscarTab (actual, next) {
        if (this.monedasAux[actual] !== undefined) {
          this.$store.dispatch('axiosMod/getData', {
            url: '/api/derechos_pendientes_total/' + this.monedasAux[actual].id + '?page=' + 1 + '&fmin=' + this.fMin + '&fmax=' + this.fMax + '&search= ',
          }).then(response => {
            // this.totales[this.monedasAux[actual].id] = response.toFixed(2)
            this.monedas.push(this.monedasAux[actual])
            Vue.set(this.totales, [this.monedasAux[actual].id], response.toFixed(2))
            Vue.set(this.open, 0, actual)
            this.terminototales[this.monedasAux[actual].id] = true
            if (this.monedasAux[next] !== undefined) {
              this.buscarTab(next, next + 1)
            } else {
              setTimeout(this.cerrarTodo, 100)
            }
          })
        }
      },
      cerrarTodo () {
        Vue.set(this.open, 0, 0)
      },
    },
  }
</script>
